<template>
  <div class="page">
    <!-- <img src="~/assets/img/bg/login.png" alt="" class="bg"> -->
    <div class="content">
      <!-- <img src="~/assets/img/logoDev.svg" alt="" class="logo"> -->
      <div class="box">
        <div class="back" @click="back" v-if="!(status==1||status==3)">
          <img src="~/assets/img/setting/back2.svg" alt="" class="icon">
          <div class="txt">{{$t('login.back')}}</div>
        </div>
        <div class="title" v-if="!(status==4&&email=='')">
          <div>
            <span v-if="((status==4&&email!=='')||status==6)">🔍</span>
            <span v-else-if="status==2||status==5">🔐</span>
            <span v-else>👋</span>
          </div>
          <div>
            <span v-if="status==1">{{$t('login.hello')}}</span>
            <span v-else-if="status==4||status==6">{{$t('login.security_requirements')}}</span>
            <span v-else-if="status==2">{{$t('login.set_title')}}</span>
            <span v-else-if="status==5">{{$t('login.reset_title')}}</span>
            <span v-else>{{$t('login.welcome_back')}}</span>
          </div>
          <div v-if="status==1" class="title_child">{{$t('login.sign_to_api')}}</div>
          <div v-else-if="status==4||status==6" class="title_child2">
            <span v-if="status!=4&&verifyWays.length>1">{{$t('login.need_verifications')}}</span>
            <span v-else>{{$t('login.need_verification')}}</span>
          </div>
          <!-- {{status==1?$t('login.register_title'):status==2?$t('login.set_title'):status==3?$t('login.login_title'):$t('login.reset_title')}} -->
        </div>
        <div class="title title2" v-if="status==4&&email==''">{{$t('login.account_email')}}</div>
        <section v-if="status==1">
          <div class="input_box" :class="[input1?'active':'']">
            <input type="text" v-model="email" pattern="^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$" onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'');this.value=this.value.replace(/\s+/g,'')" :placeholder="$t('login.input_email')" class="input" maxlength="64" @focus="input1=true" @blur="input1=false">
            <div class="send" @click="sendcode">{{sending?`${time}s`:sendTimes==0?$t('login.send_code'):$t('login.resend')}}</div>
          </div>
          <input type="text" v-model="code" :placeholder="$t('login.input_code')" class="input">
          <div class="code_tips">{{$t('login.enter_code_tips')}}</div>
          <input type="text" v-model="inviteCode" :placeholder="$t('login.input_inviteCode')" class="input" v-if="status==1">
        </section>
        <section v-else-if="status==2||status==5">
          <input type="password" v-model="password1" :placeholder="$t('login.input_password')" class="input" maxlength="16">
          <input type="password" v-model="password2" :placeholder="$t('login.input_password_again')" class="input" maxlength="16">
        </section>
        <section v-else-if="status==3">
          <input type="text" v-model="email" pattern="^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$" onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'');this.value=this.value.replace(/\s+/g,'')" :placeholder="$t('login.input_email')" class="input" maxlength="64">
          <input type="password" v-model="password" :placeholder="$t('login.input_password')" class="input" maxlength="16" @keyup.enter="submit">
        </section>
        <section v-if="status==4&&email==''">
          <input type="text" v-model="verifyEmail" pattern="^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$" onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'');this.value=this.value.replace(/\s+/g,'')" :placeholder="$t('login.input_email')" class="input" maxlength="64" @focus="input1=true" @blur="input1=false">
        </section>
        <section v-else-if="status==6||(status==4&&email!=='')">
          <div class="input_box" :class="[input2?'active':'']" v-if="(status!=4&&verifyWays.includes('email'))||(status==4&&verifyWay=='email')||(status==4&&verifyWay=='')">
            <input type="text" v-model="code" :placeholder="$t('login.input_email_code')" class="input" @focus="input2=true" @blur="input2=false">
            <div class="send" @click="sendcode">{{sending?`${time}s`:sendTimes==0?$t('login.send_code'):$t('login.resend')}}</div>
          </div>
          <div class="code_tips" v-if="(status!=4&&verifyWays.includes('email'))||(status==4&&verifyWay=='email')||(status==4&&verifyWay=='')">{{$t('login.send_code_tips',{email:email})}}</div>
          <div class="input_box" :class="[input3?'active':'']" v-if="(status!=4&&verifyWays.includes('google'))||(status==4&&verifyWay=='google')">
            <input type="text" v-model="googleCode" :placeholder="$t('setting.security.authenticator_app')" class="input" @focus="input3=true" @blur="input3=false" @input="googleCodeInputEnter">
            <div class="send" @click="paste">{{$t('setting.paste')}}</div>
          </div>
          <div class="code_tips" v-if="(status!=4&&verifyWays.includes('google'))||(status==4&&verifyWay=='google')">{{$t('login.enter_googlecode_tips')}}</div>
        </section>
        <el-button class="login" :class="[isSubmit?'active':'',loading?'click':'']" @click="submit" :loading="loading">
          {{status==1?$t('login.signUp'):status==2?$t('login.submit'):status==3?$t('login.login'):(status==4&&!email)?$t('setting.security.continue'):$t('login.submit')}}
        </el-button>
        <div class="box_tips" v-if="status==1">
          <el-checkbox class="check" v-model="checkUser" :data-trackId="2008">
            <div v-html="tips1"></div>
          </el-checkbox>
        </div>
        <div v-else-if="status==3" class="box_tips">
          <span class="terms" @click="status=4" :data-trackId="2001">{{$t('login.forgot')}}</span>
        </div>
        <div v-else-if="status==4&&email!==''" class="box_tips" :class="[verifyWays.length>1?'box_tips2':'']">
          <div class="way" @click="isShowChooseWay=true" v-if="verifyWays.length>1" :data-trackId="2016">{{$t('login.switch_verify_method')}}</div>
          <div class="way" @click="isShowContact=true" :data-trackId="2019">{{$t('login.verify_unavailable')}}</div>
        </div>
        <div v-else-if="status==6" class="box_tips">
          <span class="way" @click="isShowContact=true" :data-trackId="2014">{{$t('login.verify_unavailable')}}</span>
        </div>
      </div>
      <div class="tips" v-if="status==1">{{$t('login.have_account')}} <span class="login" @click="status=3" :data-trackId="2010" key="login_tips">{{$t('login.login_tips')}}</span></div>
      <div class="tips" v-else-if="status==3">{{$t('login.notAccount')}} <span class="login" @click="status=1" :data-trackId="2002" key="sign_tips">{{$t('login.sign_tips')}}</span></div>
    </div>
    <div class="bg-pic"></div>
    <div class="dialog" v-if="isShowContact">
      <div class="dialog_box">
        <img src="~/assets/img/setting/back2.svg" alt="" class="back" @click="isShowContact=false">
        <div class="close" @click="isShowContact=false"></div>
        <div>
          <div class="dialog_title">{{$t('setting.support.title')}}</div>
          <div class="info">
            <div class="key">Telegram</div>
            <a href="https://t.me/Nina_Tokenview" target="_blank" class="val" :data-trackId="2021" :data-param='`{"type":"telegram"}`'>https://t.me/Nina_Tokenview</a>
          </div>
          <div class="info">
            <div class="key">Twitter</div>
            <a href="https://twitter.com/tokenview2018" target="_blank" class="val" :data-trackId="2021" :data-param='`{"type":"twitter"}`'>https://twitter.com/tokenview2018</a>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog" v-if="isShowChooseWay">
      <div class="dialog_box">
        <div class="close" @click="isShowChooseWay=false" :data-trackId="2017"></div>
        <div class="dialog_title">{{$t('login.choose_authenticator')}}</div>
        <div class="way" @click="changeVerifyWay" :data-trackId="2018">
          <div class="name">{{verifyWay=='google'?$t('setting.email'):$t('setting.security.authenticator_app')}}</div>
          <img src="~/assets/img/setting/go.svg" alt="">
        </div>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import Footer from '~/components/layout/footer'
import {debounce} from '~/utils/utils'
var md5=require('md5')
export default {
  props:['params','query'],
  data() {
    return{
      email:'',
      password:'',
      code:'',
      isSubmit:false,
      status:3,//1注册，2设置密码,3登录，4忘记密码,5忘记密码重置,6登录安全验证
      input1:false,
      input2:false,
      input3:false,
      password1:'',
      password2:'',
      // MAIL_REG:/^([a-z0-9A-Z]+[-|\.|_]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/,//回溯严重
      MAIL_REG:/[a-zA-Z0-9._%+-]{1,20}@[a-zA-Z0-9.-]{1,20}\.[a-zA-Z]{2,4}/,
      PHONE_REG : /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
      PWD_REG :  /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/,
      VCODE_REG : /^\d{6,6}$/,
      time:60,
      timeout:null,
      sending:false,
      sendTimes:0,
      loadingRegister:false,
      loadingResetPassword:false,
      loadingVerify:false,
      loadingLogin:false,
      inviteCode:"",
      checkUser:false,
      verifyWay:"",
      verifyWays:[],//["google","email"]，登录后获取用户的设置，如果没设置直接写入tk
      googleCode:"",
      isShowContact:false,
      isShowChooseWay:false,
      verifyEmail:"",
    }
  },
  components: {
    Footer
  },
  created(){
    if(this.$route.query){
      if(this.$route.query.isregiter=="true"){
        this.status=1
      }
      if(this.$route.query.hasOwnProperty('inviteCode')){
        this.inviteCode=this.$route.query.inviteCode.slice(0,6)
      }
    }
  },
  destroyed() {
    if(this.timeout){
      clearTimeout(this.timeout)
      this.timeout=null
    }
  },
  watch:{
    status(now,before){
      if(before==3&&now==6){//从登录到登录验证不用清空密码
      }else{
        this.password=''
      }
      this.isSubmit=false
      if(before==3&&now==4){
        this.email=''
        this.code=''
      }
    },
    email(){
      this.changeSubmit()
    },
    code(){
      this.changeSubmit()
    },
    password(){
      this.changeSubmit()
    },
    password1(){
      this.changeSubmit()
    },
    password2(){
      this.changeSubmit()
    },
    checkUser(){
      this.changeSubmit()
    },
    verifyEmail(){
      this.changeSubmit()
    },
    googleCode(){
      this.changeSubmit()
    }
  },
  computed:{
    tips1(){
      return this.$t('login.register_tips').replace('$users',`<a href="/${this.$i18n.locale}/protocol" class="terms" target="_blank" data-trackId="2009">${this.$t('login.users')}</a>`)
    },
    loading(){
      if(this.status==1){
        if(this.loadingVerify){
          return true
        }
      }else if(this.status==2){
        if(this.loadingRegister){
          return true
        }
      }else if(this.status==3){
        if(this.loadingLogin){
          return true
        }
      }else if(this.status==4){
        if(this.loadingVerify){
          return true
        }
      }else if(this.status==5){
        if(this.loadingResetPassword){
          return true
        }
      }
      return false
    }
  },
  methods:{
    sendcode(){
      if(!this.MAIL_REG.test(this.email)){
        this.$Message(this.$t('confirm_email'))
        return
      }
      if(this.sending) return
      this.sending=true
      if(this.status==1){
        this.sendNewPhoneCode()
      }else if(this.verifyWay!=''){
        this.sendMFA()
      }else{//没开启验证
        this.resetCode()
      }
      this.timeout=setInterval(()=>{
        this.time--
        if(this.time==0){
          this.time=60
          this.sending=false
          clearTimeout(this.timeout)
          this.timeout=null
        }
      },1000)
    },
    sendNewPhoneCode(){
      this.sendTimes++
      this.$axios.post(`/v1api/register/send/email`,{
        email:this.email
      })
      .then((res)=>{
      })
    },
    sendMFA(){
      this.$axios.post(`/v1api/security/mfa/sendEmail`,{
        email:this.email
      })
      .then((res)=>{
      })
    },
    resetCode(){
      this.$axios.post(`/v1api/resetPassword/send/email`,{
        email:this.email
      })
      .then((res)=>{
      })
    },
    register(){
      if(!this.email||!this.password1||!this.password2){
        return
      }
      if(!this.MAIL_REG.test(this.email)){
        this.$Message(this.$t('confirm_email'))
        return
      }
      if(this.password1!=this.password2){
        this.$Message(this.$t('confirm_pwd'))
        return
      }
      if(!this.PWD_REG.test(this.password1)){
        this.$Message(this.$t('pwdTips'))
        this.password1=''
        this.password2=''
        return
      }
      if(this.loadingRegister){
        return
      }
      this.loadingRegister=true
      this.$axios.post(`/v1api/register/add/email`,{
        email:this.email,
        password:md5(this.password1),
        code:this.code,
        isInviteCode:this.inviteCode
      })
      .then((res)=>{
        this.loadingRegister=false
        if(res.data.code==1){
          this.$store.commit('setEmail', {email: this.email})
          this.$store.commit('setTK', res.data.data)
          this.$router.push({path:`/${this.$i18n.locale}/dashboard`})
          this.$store.commit('setGuide',{
            showGuide:true,
          })
        }
      })
      .catch((e)=>{
        this.loadingRegister=false
      })
    },
    login(){
      if(this.loadingLogin){
        return
      }
      if(!this.MAIL_REG.test(this.email)){
        this.$Message(this.$t('confirm_email'))
        return
      }
      this.loadingLogin=true
      console.log('login-start',Date.now())
      this.$axios.post(`/v1api/user/login`,{
        email:this.email,
        password:md5(this.password),
        emailCode:this.verifyWays.includes('email')?this.code:undefined,
        googleCode:this.verifyWays.includes('google')?this.googleCode:undefined,
      },{
        notMsg:true
      })
      .then((res)=>{
        console.log('login-end',Date.now())
        this.loadingLogin=false
        if(res.data.code==1){
          this.$store.commit('setEmail', {email: this.email})
          this.$store.commit('setTK', res.data.data)
          this.$router.push({path:`/${this.$i18n.locale}/dashboard`})
          if(this.verifyWays.length==0){
            this.$store.commit('setGuide',{
              showGuide:true,
            })
          }
        }else{
          this.changeSubmit()//可能有其它操作带着的输入内容了
          if(res.data.code!=10003){
            let msg=''
            if(this.$i18n.locale=='cn'){
              msg=res.data.msgCn||res.data.msg
            }else{
              msg=res.data.msg||res.data.msgCn
            }
            this.$Message(msg)
          }
          if(res.data.data){//需要登录验证
            this.verifyWays=[]
            if(res.data.data.enableEmailAuth){
              this.verifyWays.push('email')
            }
            if(res.data.data.enableGoogleAuth){
              this.verifyWays.push('google')
            }
            if(this.verifyWays.includes('email')){
              this.verifyWay='email'
            }else if(this.verifyWays.includes('google')){
              this.verifyWay='google'
            }
            this.status=6
          }
        }
      })
      .catch((e)=>{
        this.loadingLogin=false
      })
    },
    resetPassword(){
      let code=this.code
      if(this.verifyWay=="google"){
        code=this.googleCode
      }
      if(!this.email||!code||!this.password1||!this.password2){
        return
      }
      if(!this.MAIL_REG.test(this.email)){
        this.$Message(this.$t('confirm_email'))
        return
      }
      if(this.password1!=this.password2){
        this.$Message(this.$t('confirm_pwd'))
        return
      }
      if(this.loadingResetPassword){
        return
      }
      this.loadingResetPassword=true
      this.$axios.post(`/v1api/user/resetPassword/smsCode`,{
        mfaType: this.verifyWay=="google"?2:this.verifyWay=="email"?1:0,
        email:this.email,
        password:md5(this.password1),
        code:code
      })
      .then((res)=>{
        this.loadingResetPassword=false
        if(res.data.code==1){
          var msg=(this.$i18n.locale=='cn'?res.data.msgCn:res.data.msg)
          this.$Message(msg)
          this.status=3
        }
      })
      .catch((e)=>{
        this.loadingResetPassword=false
      })
    },
    verifyCode(){
      if(!this.email||!(this.code||this.googleCode)){
        return
      }
      if(!this.MAIL_REG.test(this.email)){
        this.$Message(this.$t('confirm_email'))
        return
      }
      if(this.loadingVerify){
        return
      }
      this.loadingVerify=true
      if(this.status==4&&this.verifyWay!=''){
        if(this.verifyWay=='google'&&!this.googleCode||this.verifyWay=='email'&&!this.code){
          return
        }
        let params={
          email:this.email,
        }
        if(this.verifyWay=='email'){
          params.code=this.code
        }else{
          params.googleCode=this.googleCode
        }
        this.$axios.post('/v1api/user/verify/mfa',params)
        .then((res)=>{
          this.loadingVerify=false
          if(res.data.code==1&&res.data.data){
            this.status=5
          }else{
            this.$Message(this.$t('login.code_error'))//无效验证码
          }
        })
        return
      }
      this.$axios.post(`/v1api/user/verify/smsCode`,{
        email:this.email,
        code:this.code
      })
      .then((res)=>{
        this.loadingVerify=false
        if(res.data.code==1){
          if(this.status==1){
            this.status=2
          }else if(this.status==4){
            this.status=5
          }
        }
      })
      .catch((e)=>{
        this.loadingVerify=false
      })
    },
    async submit(){
      if((this.status==2||this.status==5)&&this.password1&&this.password2){
        if(this.password1==this.password2){
          if(!this.PWD_REG.test(this.password1)){
            this.$Message(this.$t('pwdTips'))
            return
          }
        }else{
          this.$Message(this.$t('confirm_pwd'))
          return
        }
      }
      if(!this.isSubmit){
        if(this.status==1){
          if(!this.email||!this.MAIL_REG.test(this.email)){
            this.$Message(this.$t('login.input_email_tips'))
          }else if(!this.code){
            this.$Message(this.$t('login.input_code_tips'))
          }else if(!this.checkUser){
            this.$Message(this.$t('login.input_checkUser_tips'))
          }
        }
        return
      }
      if(this.status==1){
        this.verifyCode()
      }else if(this.status==2){
        this.register()
      }else if(this.status==3){
        this.login()
      }else if(this.status==4){
        if(!this.email){
          if(!this.verifyEmail||!this.MAIL_REG.test(this.verifyEmail)){
            this.$Message(this.$t('login.input_email_tips'))
            return
          }
          this.$Tongji({id:2015})
          this.loadingVerify=true
          const {code} = await this.getUserSecurityConfig(this.verifyEmail)
          this.loadingVerify=false
          if(code==1){
            this.email=this.verifyEmail
          }
          return
        }
        // this.status=5
        this.verifyCode()
      }else if(this.status==5){
        this.resetPassword()
      }else if(this.status==6){
        this.login()
      }
    },
    changeSubmit:debounce(async function(){
      this.email=this.email.trim()
      this.code=this.code.trim()
      if(this.status==1){
        if(this.email&&this.code&&this.MAIL_REG.test(this.email)&&this.checkUser){
          this.isSubmit=true
          return
        }
        this.isSubmit=false
        return
      }else if(this.status==2||this.status==5){
        if(this.password1&&this.password2&&this.password1==this.password2&&this.PWD_REG.test(this.password1)){
          this.isSubmit=true
          return
        }
        this.isSubmit=false
        return
      }
      else if(this.status==3){
        if(this.email&&this.password&&this.MAIL_REG.test(this.email)){
          this.isSubmit=true
          return
        }
        this.isSubmit=false
        return
      }else if(this.status==4){
        if(!this.email&&this.verifyEmail&&this.MAIL_REG.test(this.verifyEmail)){
          this.isSubmit=true
          return
        }
        if(this.email&&(this.code||this.googleCode)&&this.MAIL_REG.test(this.email)){
          this.isSubmit=true
          return
        }
        this.isSubmit=false
        return
      }else if(this.status==6){
        if(this.verifyWays.includes('email')&&this.verifyWays.includes('google')){
          if(this.code&&this.googleCode){
            this.isSubmit=true
            return
          }
        }else if(this.verifyWays.includes('email')){
          if(this.code){
            this.isSubmit=true
            return
          }
        }else if(this.verifyWays.includes('google')){
          if(this.googleCode){
            this.isSubmit=true
            return
          }
        }
        this.isSubmit=false
        return
      }
    },200,false),
    getUserSecurityConfig(email){
      return new Promise((resolve,reject)=>{
        this.$axios.post('/v1api/security/getUserSecurityConfig',{
          email: email
        })
        .then((res)=>{
          if(res.data.code==1&&res.data.data){
            this.verifyWays=[]
            if(res.data.data.enableEmailAuth){
              this.verifyWays.push('email')
            }
            if(res.data.data.enableGoogleAuth){
              this.verifyWays.push('google')
            }
            if(this.verifyWays.includes('email')){
              this.verifyWay='email'
            }else if(this.verifyWays.includes('google')){
              this.verifyWay='google'
            }
          }
          resolve({code:res.data.code})
        })
        .catch((e)=>{
          reject()
        })
      })
    },
    paste(){
      navigator.permissions
      .query({
        name: 'clipboard-read'
      })
      .then(result => {
        if (result.state == 'granted' || result.state == 'prompt') {
          //读取剪贴板
          navigator.clipboard.readText().then(text => {
            this.googleCode=text
          })
        } else {
          alert('请允许读取剪贴板！')
        }
      })
    },
    back(){
      if(this.status==2){
        this.status=1
      }else if(this.status==4){
        if(this.email){
          this.email=""
        }else{
          this.verifyWay=''
          this.verifyWays=[]
          this.status=3
        }
      }else if(this.status==5){
        this.status=4
        this.password1=''
        this.password2=''
      }else if(this.status==6){
        this.status=3
      }
    },
    changeVerifyWay(){
      if(this.verifyWay=='google'){
        this.verifyWay='email'
      }else{
        this.verifyWay='google'
      }
      this.isShowChooseWay=false
    },
    googleCodeInputEnter(){
      this.googleCode=this.googleCode.replace(/[^\d]/g,"")
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/.terms{
  color: #0033FF;
  cursor: pointer;
}
.page{
  // padding-top: 144px;
  // background: #F8F9FD;
  position: relative;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  .bg{
    position: absolute;
    right: 0;
    width: 100%;
  }
  .content{
    position: relative;
    // min-height: calc(100vh - 144px);
    // background: url('~assets/img/bg/login.png') no-repeat center;
    // background-size: cover;
    // padding-top: 144px;
    min-height: 100vh;
    max-width: 840px;
    min-width: 438px;
    width: 840px;
    margin: auto;
    .logo{
      display: block;
      margin: auto;
      margin-bottom: 70px;
      height: 32px;
    }
    .box{
      background: #fff;
      width: 96%;
      max-width: 438px;
      margin: 25.8% auto 0 auto;
      position: relative;
      letter-spacing: -0.14px;
      .back{
        position: absolute;
        top: -44px;
        left: 0;
        display: flex;
        align-items: center;
        color: #9E9EA7;
        cursor: pointer;
        font-size: 24px;
        .icon{
          margin-right: 4px;
        }
        .txt{
          font-size: 16px;
        }
      }
      .title{
        font-size: 24px;
        font-family: Inter-SemiBold, Inter;
        font-weight: bold;
        text-align: left;
        margin-bottom: 28px;
        .title_child{
          font-size: 16px;
          font-family: Inter-Medium, Inter;
          font-weight: 500;
          display: inline-block;
          margin: 12px 0;
        }
        .title_child2{
          font-size: 14px;
          display: inline-block;
          margin: 12px 0 8px 0;
        }
      }
      .title2{
        margin-bottom: 16px;
      }
      .input_box{
        position: relative;
        display: flex;
        align-items: center;
        margin-top: 24px;
        width: 100%;
        height: 44px;
        line-height: 44px;
        color: #000;
        font-size: 14px;
        border: 1px #E1E1E1 solid;
        border-radius: 4px;
        overflow: hidden;
        .input{
          width: 100%;
          height: 100%;
          border: none;
          padding: 0 16px;
          margin: 0;
          background: #fff;
        }
        .input:focus{
          border: 1px none;
        }
        .send{
          flex-shrink: 0;
          padding: 0 16px;
          font-family: Inter-Medium, Inter;
          color: #0033FF;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .input_box.active{
        border: 1px #0033FF solid;
      }
      .input{
        margin-top: 16px;
        width: 100%;
        height: 44px;
        line-height: 44px;
        color: #000;
        font-size: 14px;
        padding: 0 16px;
        border: 1px #E0E2E8 solid;
        border-radius: 4px;
        background: #fff;
      }
      .input:nth-child(1){
        margin-top: 0;
      }
      .input::-webkit-input-placeholder{
        color: #C0C4CC;
      }
      .input:focus{
        border: 1px #0033FF solid;
      }
      .login{
        background: #0033FF;
        color: #fff;
        font-size: 14px;
        font-family: Inter-Medium, Inter;
        font-weight: 500;
        border-radius: 4px;
        text-align: center;
        line-height: 44px;
        margin-top: 40px;
        cursor: pointer;
        width: 100%;
        padding: 0;
        border: none;
        opacity: 0.5;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .login.active{
        opacity: 1;
        // background: #000;
      }
      .login.click{
        opacity: 1;
        // background: #333;
      }
      /deep/ .el-checkbox{
        display: flex;
        align-items: flex-start;
        width: fit-content;
        max-width: 100%;
        overflow: hidden;
        word-break: break-all;
      }
      /deep/ .el-checkbox__inner {
        display: block;
        width: 14px;
        height: 14px;
        border-radius: 2px;
        border: 1px #E1E1E1 solid;
      }
      /deep/ .el-checkbox__input{
        flex-shrink: 0;
        margin-top: 3px;
      }
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        border-color: #409EFF;
        background: #409EFF;
      }
      /deep/ .el-checkbox__label{
        color: #333;
        padding-left: 8px;
        display: inline-grid;
        white-space: pre-line;
        word-wrap: break-word;
        overflow: hidden;
        line-height: 20px;
      }
      .box_tips{
        font-size: 12px;
        line-height: 16px;
        color: #333333;
        margin-top: 12px;
        .terms{
          color: #0033FF;
          cursor: pointer;
        }
        .way{
          margin-top: 16px;
          width: fit-content;
          cursor: pointer;
          color: #0033FF;
        }
        .way:nth-child(1){
          margin-top: 0;
        }
      }
      .box_tips2{
        margin-top: 32px;
      }
    }
    .tips{
      font-size: 14px;
      line-height: 24px;
      color: #000;
      margin-top: 40px;
      padding-bottom: 64px;
      text-align: center;
      .login{
        color: #0033FF;
        cursor: pointer;
      }
    }
    .code_tips{
      font-size: 12px;
      color: #9E9EA7;
      margin-top: 8px;
    }
  }
  .bg-pic{
    width: 100vh;
    height: 100vh;
    flex-shrink: 0;
    background: url('~assets/img/bg/login-bg.png') no-repeat center center;
    background-size: cover;
  }
  .dialog{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.3);
    height: 100vh;
    .dialog_box{
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      background: white;
      width: 90%;
      max-width: 438px;
      padding: 24px;
      max-height: 90vh;
      overflow: auto;
      border-radius: 8px;
      z-index: 1001;
      opacity: 1;
      .close{
        position: absolute;
        right: 16px;
        top: 16px;
        width: 16px;
        height: 16px;
        background: url('~assets/img/setting/close-menu2.svg') no-repeat;
        background-size: contain;
        cursor: pointer;
      }
      .back{
        font-size: 24px;
        color: #9E9EA7;
        margin-bottom: 20px;
        cursor: pointer;
      }
      .dialog_title{
        font-size: 20px;
        font-family: Inter-SemiBold, Inter;
        font-weight: bold;
        margin-bottom: 18px;
      }
      .info{
        display: flex;
        font-size: 14px;
        padding: 22px 0;
        border-bottom: 1px #EEEFF1 solid;
        .key{
          width: 116px;
          padding-left: 20px;
          flex-shrink: 0;
        }
      }
      .info:nth-last-child(1){
        border-bottom: none;
      }
      .way{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 58px;
        padding: 0 16px;
        margin-top: 14px;
        border-radius: 4px;
        border: 1px solid #E0E2E8;
        color: #0033FF;
        font-size: 20px;
        cursor: pointer;
        float: left;
        .name{
          color: #000;
          font-size: 14px;
          font-family: Inter-Medium, Inter;
          font-weight: 500;
        }
      }
    }
  }
}
@media screen and (max-width: 500px){
.page{
  // padding-top: mvw(100);
  .content{
    padding-top: mvw(100);
    width: 100%;
    min-width: unset;
    .logo{
      height: 20px;
    }
    .box{
      padding: 24px 20px;
      overflow: visible;
      .back{
        top: -20px;
        left: 20px;
      }
    }
  }
  .bg-pic{
    display: none;
  }
  .dialog{
    .dialog_box{
      .info{
        flex-wrap: wrap;
        .key{
          width: 100%;
          padding-left: 0;
        }
      }
    }
  }
}
}
</style>
